<template>
	<div>
		<DiscoveryTable />
	</div>
</template>

<script>
import DiscoveryTable from '@/components/DiscoveryTable/DiscoveryTable'

export default {
	name: "DiscoveryPage",
	components: {
		DiscoveryTable
	}
}
</script>

<style scoped>

</style>